module.exports = __webpack_public_path__ + "static/media/Booming.b416fe2e.jpeg";